import { render, staticRenderFns } from "./usedWork.vue?vue&type=template&id=2d6edfdc"
import script from "./usedWork.vue?vue&type=script&lang=js"
export * from "./usedWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports